import cn from 'classnames';
import { useRouter } from 'next/router';

import { Layout } from '@sravni/react-design-system/lib/Layout';

import { ANCHOR_LINKS } from './AnchorLinkList.config';
import styles from './AnchorLinkList.module.scss';

interface Props {
  withBottomMargin?: boolean;
  withTopMargin?: boolean;
  withLayout?: boolean;

  className?: string;
}

export const AnchorLinkList = ({
  withBottomMargin = true,
  withTopMargin = false,
  withLayout = true,
  className,
}: Props) => {
  const { asPath, push } = useRouter();
  const [pathWithoutQuery] = asPath.split('?');

  const content = (
    <div
      className={cn(styles.container, className, {
        [styles.withBottomMargin]: withBottomMargin,
        [styles.withTopMargin]: withTopMargin,
      })}
    >
      {ANCHOR_LINKS.map(({ label, link }) => {
        const active = pathWithoutQuery === link;

        const onClick = () => {
          if (!active) {
            push(link);
          }
        };

        return (
          <div onClick={onClick} key={label} className={active ? styles.badgeActive : styles.badge}>
            {active ? (
              label
            ) : (
              <a href={link} onClick={(e) => e.stopPropagation()}>
                {label}
              </a>
            )}
          </div>
        );
      })}
    </div>
  );

  return withLayout ? <Layout className="layout">{content}</Layout> : content;
};
